import { render, staticRenderFns } from "./SalesRoleUsers.vue?vue&type=template&id=130c8714&"
import script from "./SalesRoleUsers.vue?vue&type=script&lang=js&"
export * from "./SalesRoleUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports